/** Scopes this screen can describe in plain language. Anything else renders as its raw string —
 *  product scopes are free-form per client (`oauth_clients.allowed_scopes`) and cannot be
 *  enumerated here. Every member needs a matching key under `scope` in all four locale bundles. */
export const DESCRIBED_SCOPES = ['openid', 'profile', 'email', 'offline_access', 'address', 'phone'] as const;

export type DescribedScope = (typeof DESCRIBED_SCOPES)[number];

const DESCRIBED: ReadonlySet<string> = new Set(DESCRIBED_SCOPES);

export function isDescribedScope(scope: string): scope is DescribedScope {
  return DESCRIBED.has(scope);
}
